export { ReviewsSlider } from './ReviewsSlider';
